import api from './api';

export interface Contrato {
  id: number;
  numeroSequencial: number;
  eRematricula: boolean;
  valorMensal: number;
  percentualDescontoMensal: number;
  valorAnual: number;
  valorMatricula: number;
  formaPagamentoMatricula: 'avista' | 'parcelado' | 'isento';
  parcelasMatricula: number;
  matriculaPaga: boolean;
  valorMaterial: number;
  formaPagamentoMaterial: 'avista' | 'parcelado' | 'isento';
  parcelasMaterial: number;
  materialPago: boolean;
  parcelasMatriculaEmitidas: boolean;
  parcelasMensalidadesEmitidas: boolean;
  emitirNfse: boolean;
  alunoId: number | null;
  turmaId: number | null;
  responsavelPrincipalId: number | null;
  responsavelAlternativoId: number | null;
  aluno: { id: number; nome: string; matricula: string } | null;
  responsavelPrincipal: { id: number; nome: string; cpfCnpj?: string; telefone?: string } | null;
  responsavelAlternativo: { id: number; nome: string; cpfCnpj?: string; telefone?: string } | null;
  turma: { id: number; nome: string } | null;
  anoLetivo: { id: number; ano: number } | null;
}

export interface CreateContratoDto {
  alunoId: number;
  turmaId: number;
  anoLetivoId: number;
  responsavelPrincipalId: number;
  responsavelAlternativoId?: number;
  eRematricula?: boolean;
  valorMensal: number;
  percentualDescontoMensal?: number;
  diaVencimento?: number;
  valorMatricula?: number;
  formaPagamentoMatricula?: 'avista' | 'parcelado' | 'isento';
  parcelasMatricula?: number;
  valorMaterial?: number;
  formaPagamentoMaterial?: 'avista' | 'parcelado' | 'isento';
  parcelasMaterial?: number;
  emitirNfse?: boolean;
}

export const contratosService = {
  async create(dto: CreateContratoDto): Promise<Contrato> {
    const { data } = await api.post('/contratos', dto);
    return data;
  },

  async getAll(): Promise<Contrato[]> {
    const { data } = await api.get('/contratos');
    return data;
  },

  async getByTurma(turmaId: number): Promise<Contrato[]> {
    const { data } = await api.get(`/contratos/turma/${turmaId}`);
    return data;
  },

  async updateEmissao(
    id: number,
    data: { emitirNfse?: boolean, parcelasMatriculaEmitidas?: boolean; parcelasMensalidadesEmitidas?: boolean },
  ): Promise<Contrato> {
    const { data: result } = await api.patch(`/contratos/${id}/emissao`, data);
    return result;
  },
};
